import { CustomRangeModifier } from 'src/reducers/pageSettingsReducer/pageSettingsReducer';
import {
  getInsightsCurrentMonthRange,
  getInsightsLastNDaysRange,
  getInsightsPreviousMonthRange,
  getInsightsTodayRange,
  toInsightsDayEndSeconds,
  toInsightsDayStartSeconds,
} from 'src/utils/insightsTime';

export const convertNumberOfDaysToTimeStamp = (numberOfDays: number) =>
  numberOfDays * 24 * 60 * 60 * 1000;

// All presets anchor to the UTC calendar so every viewer's filter sends
// identical epochs (FTSV-1332); the old noon offsets only existed to survive
// the server's viewer-offset inference, which is removed.
export const getCurrentMonthRange = getInsightsCurrentMonthRange;

export const getPreviousMonthRange = getInsightsPreviousMonthRange;

export const getLastNDaysTimeRange = getInsightsLastNDaysRange;

export const getTodayTimeRange = getInsightsTodayRange;

export const datePickerRangeOptions = [
  {
    label: 'Last 7 days',
    value: getLastNDaysTimeRange(7),
  },
  {
    label: 'Last 14 days',
    value: getLastNDaysTimeRange(14),
  },
  {
    label: 'Last 30 days',
    value: getLastNDaysTimeRange(30),
  },
  {
    label: 'This Month',
    value: getCurrentMonthRange(),
  },
  {
    label: 'Previous Month',
    value: getPreviousMonthRange(),
  },
];

export const last90DaysTimeRange = getLastNDaysTimeRange(90);

export const last30DaysTimeRange = getLastNDaysTimeRange(30);

export const last14DaysTimeRange = getLastNDaysTimeRange(14);

export const datePickerRangeOptionsRevamp = [
  {
    label: 'Today',
    value: getTodayTimeRange(),
  },
  {
    label: 'Last 7 days',
    value: getLastNDaysTimeRange(7),
  },
  {
    label: 'Last 14 days',
    value: getLastNDaysTimeRange(14),
  },
  {
    label: 'Last 30 days',
    value: last30DaysTimeRange,
  },
  {
    label: 'This Month',
    value: getCurrentMonthRange(),
  },
  {
    label: 'Previous Month',
    value: getPreviousMonthRange(),
  },
];

export const getDatePickerRangeOptionsRevamp = () => [
  {
    label: 'Today',
    value: getTodayTimeRange(),
  },
  {
    label: 'Last 7 days',
    value: getLastNDaysTimeRange(7),
  },
  {
    label: 'Last 14 days',
    value: getLastNDaysTimeRange(14),
  },
  {
    label: 'Last 30 days',
    value: getLastNDaysTimeRange(30),
  },
  {
    label: 'This Month',
    value: getCurrentMonthRange(),
  },
  {
    label: 'Previous Month',
    value: getPreviousMonthRange(),
  },
];

// The range Dates' calendar fields identify the intended UTC days; re-anchor
// them to UTC instants instead of trusting the browser-local instant.
export const constructTimeRangeQueryParams = (
  timeRange: CustomRangeModifier,
  channel: string,
) => {
  const { from, to } = timeRange;
  const start = from ? toInsightsDayStartSeconds(from) : 0;
  const end = to ? toInsightsDayEndSeconds(to) : 9999999999;

  const formattedTimeRange = {
    channel,
    end: String(end),
    start: String(start),
  };
  const queryParams = new URLSearchParams(formattedTimeRange);

  return queryParams;
};

export const constructTimeRangeQueryParamsRevamped = (
  timeRange: CustomRangeModifier,
  channel: string,
) => constructTimeRangeQueryParams(timeRange, channel);

export const constructDefaultTimeRangeQueryParams = (
  timeRange: CustomRangeModifier,
) => {
  const { from, to } = timeRange;
  const start = from ? toInsightsDayStartSeconds(from) : 0;
  const end = to ? toInsightsDayEndSeconds(to) : 9999999999;

  const formattedTimeRange = {
    end: String(end),
    start: String(start),
  };

  const queryParams = new URLSearchParams(formattedTimeRange);

  return queryParams;
};

export const formatTimeForSafari = (time: string): string => {
  /**
   * expected input time format example: 2024-05-16 20:55:14.858260 UTC
   * this is not a valid format for Safair Date constructor, we need to replace - with /, and
   * remove the milliseconds after the dot.
   * expected output time format example : 2024/05/16 20:55:14 UTC
   */
  const result = time.replace(/-/g, '/').replace(/\.[0-9]*/, '');

  return result;
};
